module.exports = __webpack_public_path__ + "img/add-first-review.99a5df5b.webp";